module.exports = __webpack_public_path__ + "static/media/chess-bishop.d7a2aa1e.svg";